import { render, staticRenderFns } from "./ErrorPackageLimit.vue?vue&type=template&id=519994fd&scoped=true&"
import script from "./ErrorPackageLimit.vue?vue&type=script&lang=js&"
export * from "./ErrorPackageLimit.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPackageLimit.vue?vue&type=style&index=0&id=519994fd&prod&lang=scss&"
import style1 from "./ErrorPackageLimit.vue?vue&type=style&index=1&id=519994fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519994fd",
  null
  
)

export default component.exports